import { useEffect, useState } from 'react';
import { ChatLoading } from 'bv-components';

const ChatPreloaderView = () => {
  const [liveChatIsLoading, setLiveChatIsLoading] = useState(false);

  const hideChatPreloader = () => {
    setLiveChatIsLoading(false);
  };

  const webWidgetOpenHandler = () => {
    window.zE('webWidget:on', 'open', () => {
      // to avoid the blinking between hiding the preloader and showing the chat pop-up
      setTimeout(hideChatPreloader, 750);
    });
  };

  useEffect(() => {
    window.addEventListener('zE_show_preloader', () => {
      const liveChatIsOpened = window.zE && window.zE('webWidget:get', 'display') !== 'hidden';

      if (!liveChatIsOpened) {
        setLiveChatIsLoading(true);
      }
    }, false, { once: true });

    window.addEventListener('zE_hide_preloader', webWidgetOpenHandler, false, { once: true });
  }, []);

  return liveChatIsLoading ? (
    <ChatLoading onHideChatPreloader={hideChatPreloader} />
  ) : null;
};

export default ChatPreloaderView;
